import axiosInstance from '../lib/axios';
import { AxiosResponse } from 'axios';

export interface AnnouncementRule {
  _id?: string;
  name: string;
  description?: string;
  type: 'date_range' | 'weekly_recurring' | 'annual_recurring';
  startDate: string | Date;
  endDate?: string | Date;
  startTime?: string;
  endTime?: string;
  daysOfWeek?: number[];
  monthDay?: number;
  month?: number;
  priority?: number;
  isActive: boolean;
  createdAt?: string | Date;
  updatedAt?: string | Date;
}

export const fetchRules = async (): Promise<AnnouncementRule[]> => {
  try {
    const response: AxiosResponse<AnnouncementRule[]> = await axiosInstance.get('/announcement-rules');
    return response.data;
  } catch (error) {
    console.error('Error fetching announcement rules:', error);
    throw error;
  }
};

export const fetchRuleById = async (id: string): Promise<AnnouncementRule> => {
  try {
    const response: AxiosResponse<AnnouncementRule> = await axiosInstance.get(`/announcement-rules/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching announcement rule with id ${id}:`, error);
    throw error;
  }
};

export const createRule = async (rule: Omit<AnnouncementRule, '_id'>): Promise<AnnouncementRule> => {
  try {
    const response: AxiosResponse<AnnouncementRule> = await axiosInstance.post('/announcement-rules', rule);
    return response.data;
  } catch (error) {
    console.error('Error creating announcement rule:', error);
    throw error;
  }
};

export const updateRule = async (id: string, rule: Partial<AnnouncementRule>): Promise<AnnouncementRule> => {
  try {
    const response: AxiosResponse<AnnouncementRule> = await axiosInstance.patch(`/announcement-rules/${id}`, rule);
    return response.data;
  } catch (error) {
    console.error(`Error updating announcement rule with id ${id}:`, error);
    throw error;
  }
};

export const deleteRule = async (id: string): Promise<void> => {
  try {
    await axiosInstance.delete(`/announcement-rules/${id}`);
  } catch (error) {
    console.error(`Error deleting announcement rule with id ${id}:`, error);
    throw error;
  }
};

export const checkDateStatus = async (date: Date): Promise<{isBlocked: boolean; rule?: AnnouncementRule}> => {
  try {
    const response: AxiosResponse<{isBlocked: boolean; rule?: AnnouncementRule}> = await axiosInstance.get(
      '/announcement-rules/check', 
      { params: { date: date.toISOString() } }
    );
    return response.data;
  } catch (error) {
    console.error('Error checking date status:', error);
    throw error;
  }
};

export default {
  fetchRules,
  fetchRuleById,
  createRule,
  updateRule,
  deleteRule,
  checkDateStatus
};
